export const isSafeRedirect = (path: string | null): path is string => {
  if (!path?.startsWith('/') || path.startsWith('//')) return false;

  try {
    return (
      new URL(path, window.location.origin).origin === window.location.origin
    );
  } catch {
    return false;
  }
};
